import Grid from "@mui/material/Grid";
import { useEffect, useMemo, useState } from "react";

// @mui material components

// Argon Dashboard 2 PRO MUI components
import AdminTable from "0.Mine/0.Components/Admin/AdminTable";
import DetailBox from "0.Mine/0.Components/Reusable/DetailBox";
import { UseHandleDashboard } from "0.Mine/1.Hooks/dashboard/Dashboard";
import { useBusinessContext } from "0.Mine/2.Context/businessContext";
import ArgonBox from "components/ArgonBox";
import ArgonTypography from "components/ArgonTypography";

// Argon Dashboard 2 PRO MUI example components
import ClickableCounterCard from "examples/Cards/CounterCards/DefaultCounterCard/ClickableCounter";
import MiniGradientLineChart from "examples/Charts/LineCharts/MiniGradientLineChart";
import Footer from "examples/Footer";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import BusinessNavbar from "examples/Navbars/DashboardNavbar/businessNavbar";

function SuperAdminDashboard() {
  return (
    <DashboardLayout>
      <CRMWithContext />
    </DashboardLayout>
  );
}

function CRMWithContext() {
  return (
    <div>
      <BusinessNavbar />
      {/*<ArgonBox py={3}>
        <ArgonBox mb={3}>
          {/* Counter Cards Section
          <Grid container spacing={3} mb={3}>
            <Grid item xs={12} md={6} lg={3}>
              <ClickableCounterCard
                count={100}
                title="Vendors"
                description="Vendors"
                onClick={() => alert("You clicked on the card!")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <ClickableCounterCard
                count={0}
                title="Users"
                description="Users"
                onClick={() => alert("You clicked on the card!")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <ClickableCounterCard
                count={0}
                title="Marketers"
                description="Marketers"
                onClick={() => alert("You clicked on the card!")}
              />
            </Grid>
            <Grid item xs={12} md={6} lg={3}>
              <ClickableCounterCard
                count={0}
                title="Project Managers"
                description="Project Managers"
                onClick={() => alert("You clicked on the card!")}
              />
            </Grid>
          </Grid>

          {/* Detail Boxes Section 
          <Grid container spacing={3}>
            <Grid item xs={12} lg={4}>
              <DetailBox
                title="Dettagli Utenti Finali"
                items={[
                  {
                    label: 'Utenti Totali',
                    value: 876,
                    change: "+156 nell'ultimo mese",
                    positive: true,
                  },
                  {
                    label: 'Utenti Attivi',
                    value: 812,
                    change: '92% del totale',
                    positive: true,
                  },
                  {
                    label: 'Licenze Standard',
                    value: 634,
                  },
                  {
                    label: 'Licenze Premium',
                    value: 242,
                  },
                ]}
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <DetailBox
                title="Dettagli Vendors"
                items={[
                  {
                    label: 'Vendors Totali',
                    value: 45,
                    change: "+12 nell'ultimo mese",
                    positive: true,
                  },
                  {
                    label: 'Vendors Attivi',
                    value: 42,
                    change: '93% del totale',
                    positive: true,
                  },
                  {
                    label: 'Media Utenti per Vendor',
                    value: 17,
                  },
                  {
                    label: 'Nuovi Vendors',
                    value: 8,
                    change: 'Questo mese',
                    positive: true,
                  },
                ]}
              />
            </Grid>

            <Grid item xs={12} lg={4}>
              <DetailBox
                title="Dettagli Premium"
                items={[
                  {
                    label: 'Utenti Totali',
                    value: 876,
                    change: "+156 nell'ultimo mese",
                    positive: true,
                  },
                  {
                    label: 'Utenti Attivi',
                    value: 812,
                    change: '92% del totale',
                    positive: true,
                  },
                  {
                    label: 'Licenze Standard',
                    value: 634,
                  },
                  {
                    label: 'Licenze Premium',
                    value: 242,
                  },
                ]}
              />
            </Grid>
          </Grid>*/}

      {/* Additional Content Section */}
      <Grid container spacing={3} mt={3}>
        {/* Place for charts, graphs or other content */}
        <Grid item xs={12} lg={12}>
          {/* You can add charts or other content here */}
          <ArgonBox sx={{ height: 300, bgcolor: "background.paper", p: 2, borderRadius: 2 }}>
            {/*
                <ArgonTypography variant="h6" mb={2}>
                  Analytics Overview
                </ArgonTypography>
                */}
            <AdminTable />
          </ArgonBox>
        </Grid>
      </Grid>
      {/*</ArgonBox>
      </ArgonBox>*/}
      <Footer />
    </div>
  );
}

export default SuperAdminDashboard;
